export default __webpack_public_path__ + "static/media/LogoHeader.d4ecf781.svg";